module.exports = __webpack_public_path__ + "img/CCIsracard45.09c48be3.png";